import React from 'react';

import { useViewerData } from '@xingternal/hub';

import { ProfileCard } from './profile-card';

export const UserProfileCompletion: React.FC = () => {
  const { data } = useViewerData();
  const user = data?.user;

  return (
    <div data-testid="profile-section">
      <ProfileCard user={user} />
    </div>
  );
};
